function getAbsoluteLink(relativePath) {
  var getNewPath = function getNewPath(relativePath2) {
    var pageOrigin = window.origin;
    return "".concat(pageOrigin).concat(relativePath2);
  };
  return typeof window !== void 0 ? getNewPath(relativePath) : relativePath;
}
export { getAbsoluteLink };